import React, { useState, useEffect } from 'react';
import omitDeep from 'omit-deep-lodash';
import ReactDOM from 'react-dom';
import { createRelationship, updateRelationship } from '../../graphql/mutations';
import { getRelationship, apiListRelationships } from '../../graphql/queries';
import './NewRelationshipWizard.scss';
import { Redirect } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import TopNavbar from '../../components/TopNavbar/TopNavbar';
import gql from 'graphql-tag';
import { graphql, useQuery, useMutation } from 'react-apollo';
import Loading from '../../components/Loading/Loading';
import Step1 from './step_1';
import Step2 from './step_2';
import Step3 from './step_3';
import * as ANIMALS from '../../components/Animal/AnimalAssets';
import { track } from '../../utils/mixpanel';
import { addMirror as addMirrorMutation } from '../../graphql/mutations';

function RelationshipWizard({ history, user, mutate, match }) {
  const { loading, error, data } = useQuery(gql(getRelationship), {
    variables: { id: match.params.id }
  });

  const { t } = useTranslation();
  // const { relationship } = data.getRelationship || { relationship: {} };
  const [state, setState] = useState({
    name: '',
    partnerName: '',
    gender: `male`,
    partnerGender: `male`,
    animalId: `duck`,
    partnerAnimalId: `fox`,
    relation: 'friend'
  });
  const [relationship, setRelationship] = useState({});
  const [createdRelationship, setCreatedRelationship] = useState(null);
  const [redirectPath, setRedirectPath] = useState(null);
  const [addMirror] = useMutation(gql(addMirrorMutation));

  const [currentStep, setCurrentStep] = useState(`STEP1`);

  function nextStepSubmit(e, nextStep) {
    if (e.currentTarget.form.checkValidity()) {
      try {
        const completedStep = currentStep; // the step we are leaving now
        const payload = {
          step: completedStep,
          name: state.name,
          gender: state.gender,
          animalId: state.animalId,
          partnerName: state.partnerName,
          partnerGender: state.partnerGender,
          partnerAnimalId: state.partnerAnimalId,
          relation: state.relation,
          isEdit: Boolean(state.id)
        };
        track('APP_Felt_NR_Step_Completed', payload);
      } catch (_) {}
      setCurrentStep(nextStep);
      return e.preventDefault();
    }
  }
  useEffect(() => {
    if (!loading && match.params.id) {
      const { name, partnerName, gender, partnerGender, animalId, partnerAnimalId, relation } =
        data.getRelationship;
      setState({
        id: match.params.id,
        name,
        partnerName,
        gender,
        partnerGender,
        animalId,
        partnerAnimalId,
        relation
      });

      setRelationship({
        name,
        partnerName,
        gender,
        partnerGender,
        animalId,
        partnerAnimalId,
        relation
      });
    }
  }, [loading]);

  useEffect(() => {
    if (currentStep === 'SAVE') {
      let { owner, __typename, ...relationship } = state;
      console.log(relationship);
      mutate({ variables: { input: { ...omitDeep(relationship, `__typename`) } } }).then(
        (result) => {
          const queryKey = Object.keys(result.data)[0];
          const relationship = result.data[queryKey];

          ReactDOM.unstable_batchedUpdates(() => {
            setState({ ...relationship });
            setCreatedRelationship(relationship);
            console.log('new relationship ', relationship);
            setCurrentStep('FINISH');
          });
        }
      );
    }
  }, [mutate, currentStep]);

  // After finishing, decide where to go: if no entries (mirrors), create one and go straight to Journey
  useEffect(() => {
    async function handleFinish() {
      try {
        const relationshipId = state.id;
        // Refetch relationship to see if backend already created the first mirror
        let mirrorIdFromServer = null;
        if (relationshipId) {
          try {
            const token = localStorage.getItem('token');
            const query = {
              query: `query GetRelationship($id: String!) { getRelationship(id: $id) { id mySideMirrors { id createdAt } } }`,
              variables: { id: relationshipId }
            };
            const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/graphql`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Authorization: token ? 'Bearer ' + token : undefined
              },
              body: JSON.stringify(query)
            });
            const json = await res.json();
            const mirrors = json?.data?.getRelationship?.mySideMirrors || [];
            if (mirrors.length > 0) {
              mirrorIdFromServer = mirrors[0].id; // latest first on server side is fine
            }
          } catch (e) {
            console.warn('Refetch relationship failed, will fallback to creating a mirror');
          }
        }
        if (relationshipId && !mirrorIdFromServer) {
          // Fallback: create one only if none found
          const res = await addMirror({ variables: { input: { relationshipId } } });
          mirrorIdFromServer = res?.data?.addMirror?.id || null;
        }
        if (relationshipId && mirrorIdFromServer) {
          setRedirectPath(`/relationship/${relationshipId}/journey/${mirrorIdFromServer}`);
          return;
        }
        // fallback: go to journeys list
        if (relationshipId) setRedirectPath(`/relationship/${relationshipId}`);
      } catch (e) {
        console.error('Auto-create first journey failed', e);
        if (state.id) setRedirectPath(`/relationship/${state.id}`);
      }
    }
    if (currentStep === 'FINISH' && !redirectPath) {
      handleFinish();
    }
  }, [currentStep, createdRelationship, redirectPath, addMirror, state.id]);

  let content;
  let pageStyle = {};
  switch (currentStep) {
    case 'STEP1':
      pageStyle.background = `${ANIMALS.default[state.animalId].color}`;
      content = (
        <Step1
          user={user}
          name={state.name}
          gender={state.gender}
          animalId={state.animalId}
          changeStep={(step, e) => nextStepSubmit(e, step)}
          changeName={(name) => setState({ ...state, name: name })}
          changeSex={(gender) => setState({ ...state, gender: gender })}
          changeAnimal={(animalId) => {
            setState({ ...state, animalId: animalId });
          }}
        />
      );
      break;
    case 'STEP2':
      pageStyle.background = `${ANIMALS.default[state.partnerAnimalId].color}`;
      content = (
        <Step2
          user={user}
          name={state.partnerName}
          gender={state.partnerGender}
          animalId={state.partnerAnimalId}
          changeStep={(step, e) => nextStepSubmit(e, step)}
          changeName={(name) => setState({ ...state, partnerName: name })}
          changeSex={(gender) => setState({ ...state, partnerGender: gender })}
          changeAnimal={(animalId) => {
            setState({ ...state, partnerAnimalId: animalId });
          }}
        />
      );
      break;
    case 'STEP3':
    case 'SAVE':
      pageStyle.background = `linear-gradient(110deg, ${
        ANIMALS.default[state.animalId].color
      } 50%, ${ANIMALS.default[state.partnerAnimalId].color} 50%)`;
      content = (
        <Step3
          user={user}
          name={state.name}
          partnerName={state.partnerName}
          animalId={state.animalId}
          partnerAnimalId={state.partnerAnimalId}
          relation={state.relation}
          gender={state.gender}
          mySideMirrors={relationship.mySideMirrors}
          partnerGender={state.partnerGender}
          changeStep={(step, e) => nextStepSubmit(e, step)}
          changeRelation={(relation) => setState({ ...state, relation: relation.value })}
        />
      );
      break;
    case 'FINISH':
      if (redirectPath) {
        return (
          <Redirect
            to={{
              pathname: redirectPath,
              state: { relationship: createdRelationship || relationship }
            }}
          />
        );
      }
      return <Loading />;

    default:
      throw Error(`Wrong Step`);
  }
  const title = state.id
    ? t(`create_new_relationship.edit_title`)
    : t(`create_new_relationship.new_title`);
  if (loading) return <Loading />;
  return (
    <>
        <form className="relationship-wizard-page pageTopPadding" style={pageStyle}>
          {content}
        </form>
    </>
  );
}

const NewRelationshipWizard = graphql(gql(createRelationship), {
  options: {
    refetchQueries: [{ query: gql(apiListRelationships) }],
    awaitRefetchQueries: true
  }
})(RelationshipWizard);
const EditRelationshipWizard = graphql(gql(updateRelationship), {
  // options: props =>({
  //   variables:{ id: props.match.params.id },
  //   refetchQueries: [{ query: gql(getRelationship) }],
  //   awaitRefetchQueries: true
  // })
})(RelationshipWizard);

export { NewRelationshipWizard, EditRelationshipWizard };
